import React from "react";
import { Button } from "@disco/disco_core";

import useTrack, { eventTypes } from "../../hooks/useTrack";
import { DISCO_COLLECTIVE_URL } from "../../conf";
import isFunction from "../../utils/isFunction";
import accessibilityProvider from "../../utils/accessibilityProvider";
import { WIDGET_ELEMENT_CLICK_TARGET } from "../../event_conf";

const DiscoCollectiveButton = ({ onClick: onClickProp, children, ...rest }) => {
	const track = useTrack();

	const onClick = () => {
		track(eventTypes.WIDGET_ELEMENT_CLICK, {
			initiatingTarget: WIDGET_ELEMENT_CLICK_TARGET.CONSUMER_REDIRECT,
		});

		if (isFunction(onClickProp)) {
			onClickProp();
		}
	};

	return (
		<Button
			{...rest}
			Element={"a"}
			target="_blank"
			rel="noopener noreferrer"
			href={DISCO_COLLECTIVE_URL}
			{...accessibilityProvider({
				role: "link",
				name: "Disco Collective",
			})}
			onClick={onClick}
		>
			{children}
		</Button>
	);
};

export default DiscoCollectiveButton;
